import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center mb-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "me-1 ms-auto" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-pill badge-app-primary" }, " New ")
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.cdc.gov/coronavirus/2019-ncov/index.html",
  rel: "noopener noreferrer",
  target: "_blank"
}, " COVID-19: CDC Coding Guidance ", -1 /* HOISTED */)
const _hoisted_4 = { class: "table table-responsive-md border border-gray overflow-auto" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "ICD-10 Code"),
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", null, "Start Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Resolution Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableEmpty = _resolveComponent("TableEmpty")!
  const _component_PastDiagnosisRow = _resolveComponent("PastDiagnosisRow")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("button", {
        class: "btn btn-primary btn-xs ms-2",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addDiagnosis()))
      }, "Add Diagnosis")
    ]),
    _createVNode(_component_Pagination, {
      ref: "paginationInstance",
      "page-changed": _ctx.pageChangedCallback,
      "is-loading": _ctx.isLoading,
      "page-size": _ctx.pageLimit,
      "show-page-size-options": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createCommentVNode("Empty Table"),
          _createElementVNode("tbody", null, [
            (_ctx.diagnosis?.length === 0 && _ctx.newDiagnosis?.length === 0)
              ? (_openBlock(), _createBlock(_component_TableEmpty, {
                  key: 0,
                  "col-span": _ctx.columns,
                  component: "diagnoses",
                  "secondary-message": "No Diagnoses to Display"
                }, null, 8 /* PROPS */, ["col-span"]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Existing Diagnoses "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diagnosis, (diag, index) => {
              return (_openBlock(), _createBlock(_component_PastDiagnosisRow, {
                diag: diag,
                onCancelEditDiagChanges: _ctx.cancelEditDiagChanges,
                "delete-diagnosis": _ctx.deleteDiagnosis,
                "move-diagnosis-up": _ctx.moveDiagnosis,
                "move-diagnosis-down": _ctx.moveDiagnosis,
                first: index === 0,
                last: index === _ctx.diagnosis.length - 1,
                index: index,
                "current-view": "edit"
              }, null, 8 /* PROPS */, ["diag", "onCancelEditDiagChanges", "delete-diagnosis", "move-diagnosis-up", "move-diagnosis-down", "first", "last", "index"]))
            }), 256 /* UNKEYED_FRAGMENT */)),
            _createCommentVNode(" New Diagnoses "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newDiagnosis, (diag, index) => {
              return _withDirectives((_openBlock(), _createBlock(_component_PastDiagnosisRow, {
                key: diag.id,
                diag: diag,
                "is-add-requested": _ctx.isAddRequested,
                "save-new-diagnosis": _ctx.saveNewDiagnosis,
                "cancel-save-new-diagnosis": _ctx.cancelSaveNewDiagnosis,
                "is-new-terminal": _ctx.isNewTerminal,
                index: index,
                "current-view": "add"
              }, null, 8 /* PROPS */, ["diag", "is-add-requested", "save-new-diagnosis", "cancel-save-new-diagnosis", "is-new-terminal", "index"])), [
                [_vShow, _ctx.newDiagnosis.length > 0]
              ])
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page-changed", "is-loading", "page-size"])
  ], 64 /* STABLE_FRAGMENT */))
}